// Ant Design 主題配置
export const antdTheme = {
  token: {
    colorPrimary: '#1890ff',
    borderRadius: 6,
    fontSize: 14,
  },
  components: {
    Button: {
      borderRadius: 6,
    },
    Input: {
      borderRadius: 6,
    },
    Select: {
      borderRadius: 6,
    },
    DatePicker: {
      borderRadius: 6,
    },
  },
};

// 通用樣式常量
export const commonStyles = {
  container: {
    width: '100%',
    height: '100%',
  },
  filterPanel: {
    marginBottom: '24px',
    padding: '16px',
    backgroundColor: '#fafafa',
    borderRadius: '8px',
    border: '1px solid #f0f0f0'
  },
  ruleItem: {
    marginBottom: '8px',
    padding: '8px 12px',
    backgroundColor: '#fafafa',
    borderRadius: '6px'
  },
  actionBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '16px',
    paddingTop: '16px',
    borderTop: '1px solid #f0f0f0'
  }
};

